const removeDiacritics = require('diacritics').remove;

export default function (string: any) {
  let slug = string.replace(/[,;.]/g, '').replaceAll(' ', '-');
  slug = removeDiacritics(slug);
  return slug.toLowerCase();
}
